import React from 'react';
import { HiddenClipProps } from './HiddenClip.types';
import './HiddenClip.scss';

const HiddenClip = ({ text }: HiddenClipProps) => {
  return <span className="tfl-hidden-clip">{text}</span>;
};

export default HiddenClip;
